import type { ShelfRowData } from '@coorum-research/core/src/components/stamp-rallies/GameCollectionShelfRow'
import type { GetGameStampRallyResponse } from '@coorum-research/shared-common/api-response/game-stamp-rally.schema'

const imageTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/svg+xml', 'image/webp']

/**
 * 収集数を計算する
 */
export function calcTotalCount(campaigns: GetGameStampRallyResponse['campaigns']) {
  const allAnswers = campaigns.flatMap(campaign => campaign.answers)
  return allAnswers.length
}

/**
 * 種類数を計算する
 */
export function calcTypeCount(campaigns: GetGameStampRallyResponse['campaigns']) {
  const answersArr = campaigns.map(campaign => campaign.answers)
  return answersArr.reduce((sum, answers) => {
    return sum + (answers.length > 0 ? 1 : 0)
  }, 0)
}

/**
 * 最大数を計算する
 */
export function calcMaxCount(campaigns: GetGameStampRallyResponse['campaigns']) {
  const answersArr = campaigns.map(campaign => campaign.answers)
  return answersArr.length > 0 ? Math.max(...answersArr.map(answers => answers.length)) : 0
}

/**
 * スタンプラリーのキャンペーンデータを元に、棚のデータを作成する
 */
export function makeShelfData(campaigns: GetGameStampRallyResponse['campaigns']): ShelfRowData[] {
  return campaigns.map((campaign) => {
    const stampImageQuestionId = campaign.stampImageQuestionId
    const items = campaign.answers.map((answer) => {
      if (stampImageQuestionId) {
        const surveyAnswer = answer.surveyAnswer[stampImageQuestionId]
        if (Array.isArray(surveyAnswer)) {
          const imageAnswer = surveyAnswer[0]
          if (typeof imageAnswer === 'object' && imageTypes.includes(imageAnswer.type)) {
            return {
              answerId: answer.id,
              imageUrl: imageAnswer.content,
            }
          }
        }
      }
      return {
        answerId: answer.id,
        imageUrl: null,
      }
    })

    return {
      campaignId: campaign.id,
      campaignImageUrl: campaign.imageUrl || null,
      items,
    }
  })
}
